module.exports = __webpack_public_path__ + "5dc2ada0d42849e0ed2e3994cb83eaeb.png";